import { Injectable } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { Sandbox } from "../sandbox";
import {
  getBioSeal, setDefaultResult,
} from "../../store/actions/bioseal.action";
import { GlobalState } from "../../store/state/global.state";
import { FaceState } from "../../store/state/face.state";
import { combineLatest, Observable, Subject } from "rxjs";
import { BioSealState } from "../../store/state/bioseal.state";
import { map, filter, takeUntil, take } from "rxjs/operators";
import { AccreditationSTEP, CovidTestSTEP, STEP, VaccinationSTEP } from "../../model/steps.model";
import { base32 } from "rfc4648";
import { base64 } from "rfc4648";
import { USECASE } from "../../model/usecase.model";
declare var bwipjs;

@Injectable()
export class DisplaySanbox extends Sandbox {
  @Select(GlobalState.getToken) token: Observable<string>;
  @Select(FaceState.getFace) faceImage: Observable<string>;
  @Select(BioSealState.getBioSeal) bioseal: Observable<any>;
  @Select(BioSealState.isBioSealReady) isLoaded: Observable<boolean>;
  @Select(BioSealState.isBioSealError) isError: Observable<boolean>;
  @Select(BioSealState.isBioSealLoading) isLoading: Observable<boolean>;
  @Select(BioSealState.getQRcodeResult) qrCode: Observable<any>;
  @Select(BioSealState.getDatamatrixResult) datamatrix: Observable<any>;
  @Select(GlobalState.getVerificationUrl) verificationUrl: Observable<string>;
  @Select(GlobalState.getBioSealUrl) biosealUrl: Observable<string>;
  @Select(GlobalState.getStep) step: Observable<any>;
  barCode2DUrl: string;
  is2DTypeQr: boolean;
  isDisabled: boolean;
  destroyed: Subject<boolean> = new Subject<boolean>();
  @Select(GlobalState.getBarcodeType) barcodeType: Observable<string>; x
  @Select(BioSealState.getFirstName) firstName: Observable<string>;
  @Select(BioSealState.getLastName) lastName: Observable<string>;
  @Select(BioSealState.getFunction) function: Observable<string>;
  @Select(BioSealState.getEventName) eventName: Observable<string>;
  @Select(BioSealState.getEventAddress) eventAddress: Observable<string>;
  @Select(BioSealState.getEventDate) eventDate: Observable<string>;
  @Select(BioSealState.getEventTime) eventTime: Observable<string>;
  @Select(BioSealState.isParkingAuthorized) parking: Observable<boolean>;
  @Select(BioSealState.isGrandstandAuthorized) grandstand: Observable<boolean>;
  @Select(BioSealState.isPressAuthorized) press: Observable<boolean>;
  @Select(BioSealState.isVIPAuthorized) vip: Observable<boolean>;
  @Select(BioSealState.areCloakroomsAuthorized) cloakrooms: Observable<boolean>;
  @Select(BioSealState.isRestaurantAuthorized) restaurant: Observable<boolean>;
  constructor(private store: Store) {
    super(store);
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  init() {
    this.store.dispatch(new setDefaultResult());
  }

  initBarcode() {
    const newCanvas = document.createElement("canvas");
    newCanvas.setAttribute('class', 'bwipjs-canvas');
    newCanvas.setAttribute('style', 'width: 255px; margin: 5%;');
    newCanvas.width = 300;
    newCanvas.height = 300;

    combineLatest([this.isLoaded, this.barcodeType, this.bioseal]).pipe(takeUntil(this.destroyed)).subscribe(
      ([_isLoaded, _barcodeType, _bioseal]) => {
        if (_isLoaded && _bioseal) {
          this.is2DTypeQr = false;
          bwipjs.toCanvas(newCanvas, {
            bcid: _barcodeType === "QR" ? "qrcode" : "datamatrix", // Barcode type
            text: base32.stringify(base64.parse(_bioseal.vds)), // Text to encode
            includetext: true, // Show human-readable text
            padding: 15,
            backgroundcolor: "ffffff",
          });
          this.barCode2DUrl = newCanvas.toDataURL("image/png");
          setTimeout(() => {
            document.getElementById("bwipjs-result").innerHTML = "";
            document.getElementById("bwipjs-result").appendChild(newCanvas);
          });
        }
      }
    );
  }

  getBioseal() {
    return combineLatest([
      this.usecase,
      this.step,
      this.token,
      this.faceImage,
      this.biosealUrl,
      this.barcodeType,
    ]).pipe(
      map(([_useCase, _step, token, image, biosealUrl, barcodeType]) => {
        if (
          (_step === STEP.BIOSEAL_DISPLAY && _useCase === USECASE.GENERIC) ||
          (_step === VaccinationSTEP.BIOSEAL_DISPLAY && _useCase === USECASE.VACCINATION) ||
          (_step === CovidTestSTEP.BIOSEAL_DISPLAY && _useCase === USECASE.COVID_TEST) ||
          (_step === AccreditationSTEP.BIOSEAL_DISPLAY && _useCase === USECASE.ACCREDITATION)
        ) {
          this.isDisabled = true;
          if (token) {
            this.store.dispatch(
              new getBioSeal({
                token: token,
                face: image,
                url: biosealUrl,
                barcode: barcodeType,
                usecase: _useCase,
              })
            );
          }
        }
      })
    );
  }

  getResult(): Observable<any> {
    return combineLatest([
      this.bioseal,
      this.barcodeType,
      this.qrCode,
      this.datamatrix,
    ]).pipe(
      map(([bioseal, barcodeType, qrCode, datamatrix]) => {

        return (
          "data:image/png;base64," +
          btoa(
            new Uint8Array(bioseal).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          )
        );
      })
    );
  }

  saveFile() {
    this.isDisabled = false;
  }

}
